import API from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IStatusResponse } from '@umu/umu-types';

interface IInput {
    activity_id: string;
    metrics: number;
    is_minus: '0' | '1'; // 0 加，1 减
    obj_id: string;
}
export const changeTeamScore = (input: IInput): Promise<IStatusResponse> => {
    const param = {
        ...input,
        obj_type: '1', // 指标分数
    };
    return fetchData(API.CHANGE_COURSEPK_TEAM_SCORE, JSON.stringify(param));
};
